import { DiscoveryApi } from '@backstage/core-plugin-api';
import { UtilityApi } from '../../api';

export const UtilityEndpoints = {
  availability: '/availability',
};

/**
 * Utility service for AI Ecosystem utility functionalities
 */
export class UtilityService implements UtilityApi {
  private readonly discoveryApi: DiscoveryApi;

  constructor(discoveryApi: DiscoveryApi) {
    this.discoveryApi = discoveryApi;
  }

  /** @inheritdoc */
  async getNameAvailability(
    name: string,
    type: string,
    excludeId?: string,
  ): Promise<{ available: boolean }> {
    const contentType = 'application/json';
    const proxyUrl = await this.discoveryApi.getBaseUrl('aiecosystem');

    const queryParams = new URLSearchParams();
    queryParams.append('name', name);
    queryParams.append('resource_type', type);

    if (excludeId) {
      queryParams.append('exclude_id', excludeId);
    }

    const response = await fetch(
      `${proxyUrl}${UtilityEndpoints.availability}?${queryParams.toString()}`,
      {
        method: 'GET',
        headers: {
          Accept: `${contentType}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error(
        `Error - Statuscode ${response.status} - ${response.statusText} - Failed to check agent name availability.`,
      );
    }

    const data = await response.json();
    return { available: data.available };
  }
}
